import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const AdminLoginPage = lazy(() => import('../pages/admin-login/page'));
const ForgotPasswordPage = lazy(() => import('../pages/forgot-password/page'));
const ResetPasswordPage = lazy(() => import('../pages/reset-password/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin-dashboard/page'));
const RastreioPage = lazy(() => import('../pages/rastreio/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/admin-login',
    element: <AdminLoginPage />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/admin/dashboard',
    element: (
      <ProtectedRoute>
        <AdminDashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/rastreio',
    element: <RastreioPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
